import { useAppSelector } from "@/hooks/redux";

import { QueueTaskStatus } from "./useAsyncTaskQueue";

export const useQueueInfo = () => {
    const { requestQueue, requestQueueStatus } = useAppSelector(
        (s) => s.offline,
    );

    const requestQueueLength = requestQueue.filter(
        (q) => q.status !== QueueTaskStatus.Error,
    ).length;

    const hasPending = requestQueueLength > 0;

    return {
        hasPending,
        isRunning: requestQueueStatus.isRunning,
    };
};
